import { GB } from "@shared/constants/constants.ts";
import type { GetSubscriptionTrafficForPeriodV2Response } from "@shared/services/usageExposer/getSubscriptionTrafficForPeriod.ts";

export default async (): Promise<GetSubscriptionTrafficForPeriodV2Response> => ({
  traffic: {
    totalDownloadBytes: 12 * GB,
    totalUploadBytes: 3 * GB,
    totalTrafficBytes: 15 * GB,
  },
});
